import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbThickIntroBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`thick-intro ${props.attributes.className ? props.attributes.className : ''} ${classes.thickIntro} ${classes.thickIntroTheme}`}>
        {blocks[0]}
        {blocks[1]}
        {props.attributes.hasButton &&
            blocks[2]
        }
    </div>
};

export const CgbThickIntroBlockFragment = graphql`
  fragment CgbThickIntroBlock on WpBlock {
    ... on WpCgbThickIntroBlock {
        name
        attributes {
            className
            hasButton
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbThickIntroBlockPreview = `
    ... on CgbThickIntroBlock {
        name
        attributes {
            className
            hasButton
        }
    }
`;